var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoreVerticalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "6181603C-C04D-4857-83E7-6242E29E9952") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web-app",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "web-social",
    transform: "translate(-838, -381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "more-vertical-icon-copy",
    transform: "translate(838, 381)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,19.2692 C11.5875,19.2692 11.2344,19.1223 10.9406,18.8286 C10.6469,18.5348 10.5,18.1817 10.5,17.7692 C10.5,17.3567 10.6469,17.0036 10.9406,16.7099 C11.2344,16.4161 11.5875,16.2693 12,16.2693 C12.4125,16.2693 12.7656,16.4161 13.0593,16.7099 C13.3531,17.0036 13.5,17.3567 13.5,17.7692 C13.5,18.1817 13.3531,18.5348 13.0593,18.8286 C12.7656,19.1223 12.4125,19.2692 12,19.2692 Z M12,13.5 C11.5875,13.5 11.2344,13.3531 10.9406,13.0594 C10.6469,12.7656 10.5,12.4125 10.5,12 C10.5,11.5875 10.6469,11.2344 10.9406,10.9407 C11.2344,10.6469 11.5875,10.5 12,10.5 C12.4125,10.5 12.7656,10.6469 13.0593,10.9407 C13.3531,11.2344 13.5,11.5875 13.5,12 C13.5,12.4125 13.3531,12.7656 13.0593,13.0594 C12.7656,13.3531 12.4125,13.5 12,13.5 Z M12,7.73076 C11.5875,7.73076 11.2344,7.58389 10.9406,7.29014 C10.6469,6.9964 10.5,6.64329 10.5,6.23079 C10.5,5.8183 10.6469,5.46519 10.9406,5.17144 C11.2344,4.8777 11.5875,4.73083 12,4.73083 C12.4125,4.73083 12.7656,4.8777 13.0593,5.17144 C13.3531,5.46519 13.5,5.8183 13.5,6.23079 C13.5,6.64329 13.3531,6.9964 13.0593,7.29014 C12.7656,7.58389 12.4125,7.73076 12,7.73076 Z",
    id: "Shape",
    fill: "#026D7C",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVerticalIcon);
export default __webpack_public_path__ + "static/media/more-vertical-icon.3e19f9be97f66958da529e5e1dd6a9ee.svg";
export { ForwardRef as ReactComponent };